import { useI18n } from "../i18n/I18nContext";

export default function Footer() {
    const { t } = useI18n();

    return (
        <footer data-testid="site-footer" className="bg-white border-t border-slate-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                    <a href="#top" className="flex items-center gap-2">
                        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#10B981] text-white font-display font-black text-lg shadow-sm">
                            €
                        </span>
                        <span className="font-display font-black text-xl tracking-tight text-slate-900">
                            VATcalc<span className="text-[#10B981]">.eu</span>
                        </span>
                    </a>
                    <p className="mt-3 text-sm text-slate-600 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
                </div>

                <div className="text-sm">
                    <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500">
                        {t("footer.resources")}
                    </div>
                    <ul className="mt-3 space-y-2">
                        <li>
                            <a href="#calculator" data-testid="footer-link-calculator" className="text-slate-700 hover:text-slate-900">
                                {t("nav.calculator")}
                            </a>
                        </li>
                        <li>
                            <a href="#rates" data-testid="footer-link-rates" className="text-slate-700 hover:text-slate-900">
                                {t("nav.vatRates")}
                            </a>
                        </li>
                        <li>
                            <a href="#faq" data-testid="footer-link-faq" className="text-slate-700 hover:text-slate-900">
                                {t("nav.faq")}
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="text-sm">
                    <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500">
                        {t("footer.company")}
                    </div>
                    <ul className="mt-3 space-y-2">
                        <li>
                            <a href="#" data-testid="footer-link-about" className="text-slate-700 hover:text-slate-900">
                                {t("footer.about")}
                            </a>
                        </li>
                        <li>
                            <a href="#" data-testid="footer-link-privacy" className="text-slate-700 hover:text-slate-900">
                                {t("footer.privacy")}
                            </a>
                        </li>
                        <li>
                            <a href="#" data-testid="footer-link-contact" className="text-slate-700 hover:text-slate-900">
                                {t("footer.contact")}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
                    <div data-testid="footer-update-line">
                        {t("footer.lastUpdated")}{" "}
                        <span className="font-semibold text-slate-700">{t("footer.updateMonth")}</span> — {t("footer.source")}
                    </div>
                    <div data-testid="footer-disclaimer" className="max-w-xl md:text-right leading-relaxed">
                        {t("footer.disclaimer")}
                    </div>
                </div>
            </div>
        </footer>
    );
}
